<template>
    <section>
        <div class="sp-title">用户管理</div>
        <div class="sp-nav"><span class="sp-nav-item">基础数据维护</span><span class="sp-nav-item-sple">/</span><span class="sp-nav-item">用户管理</span></div>

<!--        <div class="ju-left"><el-button @click="openPanel" type="primary">新增用户</el-button></div>-->
        <template>
            <el-table
                    :data="tableData"
                    stripe
                    style="width: 100%">
                <el-table-column
                        prop="loginName"
                        label="用户名"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="姓名"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="手机号"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="createDateStr"
                        width="200"
                        label="创建日期">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                >
                    <template slot-scope="scope">
<!--                        <el-button @click="modf(scope.row)" type="text" size="small">修改</el-button>-->
<!--                        <el-button @click="deleterow(scope.row.id)" type="text" size="small">删除</el-button>-->
                        <el-button @click="modfrole(scope.row.id)" type="text" size="small">配置角色</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page="pageNo"
                    @current-change="eventPage"
                    style="text-align: right;padding: 10px 0px;background-color: #fff"
            >
            </el-pagination>
        </template>
        <el-dialog
                title="配置菜单"
                :visible.sync="showRole"
                width="50%"
                :before-close="handleCloseRole">
            <el-form
                    style="display: flex;"
                    ref="addrolef"
                    label-position="left"
                    label-width="80px">
                <el-form-item label="选择角色">
                    <el-checkbox-group v-model="selectRole" style="text-align: left">
                        <el-checkbox v-for="(item,index) in rolesInfo"
                                     :key="index"
                                     :label="item.name"
                        ></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveroles">确 定</el-button>
            </span>

        </el-dialog>
    </section>
</template>

<script>
    import {updateUser,delUser,saveUser,getNewUserList} from '../api/user'
    import {getRoleList} from '../api/role'
    import {saveUserRoles,getUserRoles} from '../api/userrole'
    import {ERR_OK} from "../jslib/config";
    import md5 from 'blueimp-md5'
    export default {
        data() {
            return {
                selectRole:[],
                rolesInfo:[],
                labelPosition:'left',//top、left right
                addUserInfo:{},
                tableData: [],
                total:0,
                pageNo:1,
                pageSize:5,
                showAdd:false,
                showRole:false,
                userrules:{
                    loginName: [
                        { required: true, message: '请输入用户账号', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请输入用户名称', trigger: 'blur' }
                    ],
                },
                currentuserId:'',
            };
        },
        created() {
            this.topage(1);
            getRoleList().then(res=>{
                if (res!=undefined&&res.resultCode === ERR_OK) {
                    this.rolesInfo = res.list
                }
            })
        },
        mounted() {
        },
        methods: {
            saveroles(){
                if(this.selectRole==undefined||this.selectRole==null||this.selectRole.length==0){
                    this.$message({
                        type: 'success',
                        message: '请选择一个角色!'
                    });
                    return;
                }
                var rids = []
                for(var i=0;i<this.rolesInfo.length;i++){
                    var tmp = this.rolesInfo[i];
                    if(this.isinSelectRole(tmp.name)){
                        rids.push(tmp.id);
                    }
                }

                var idsstr = '';
                for(var i=0;i<rids.length;i++){
                    if(i==rids.length-1){
                        idsstr+=(rids[i])
                    }else{
                        idsstr+=(rids[i]+',')
                    }
                }
                saveUserRoles(this.currentuserId,idsstr).then(res=>{
                    if (res!=undefined&&res.resultCode === ERR_OK) {
                        this.$message({
                            type: 'success',
                            message: '设置成功!'
                        });
                        this.handleCloseRole()
                    }
                })
            },
            isinSelectRole(str){
                for(var i=0;i<this.selectRole.length;i++){
                    if(this.selectRole[i]==str){
                        return true;
                    }
                }
                return false;
            },
            deleterow(id){
                this.$confirm('此操作将删除该菜单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delUser(id).then(res=>{
                        if (res!=undefined&&res.resultCode === ERR_OK) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            var afterL = this.tableData.length
                            var pn = this.pageNo
                            if(afterL<=1){
                                pn--;
                            }
                            if(pn<=0){
                                pn = 1
                            }
                            this.topage(pn);
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            modfrole(uid){
                this.currentuserId = uid
                getUserRoles(uid).then(res=>{
                    if (res!=undefined&&res.resultCode === ERR_OK) {
                        this.selectRole =  res.selectRole
                    }
                })

                this.showRole = true;

            },
            handleCloseRole(){
                this.showRole = false;
            },
            openPanel(){
                this.showAdd = true;
                this.addUserInfo = {}
            },
            handleClose(){
                this.showAdd = false;
            },
            modf(obj){
                this.addUserInfo = obj
                this.addUserInfo.password = '******'
                this.showAdd = true;
            },
            eventPage(e){
                this.topage(e);
            },
            topage(pageNo){
                if(this.pageNo != pageNo){
                    this.pageNo = pageNo
                }
                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中，请稍后！',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                getNewUserList(pageNo,this.pageSize).then(res=>{
                    if (res!=undefined&&res.resultCode === ERR_OK) {
                        if(res.page==undefined||res.page.records==undefined){
                            return
                        }
                        this.tableData = res.page.records
                        this.total = res.page.total
                    }
                    loading.close()
                })
            },
            saveobj(){
                this.$refs['adduserf'].validate((valid) => {
                    if (valid) {
                        this.tosave();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            tosave(){
                if(this.addUserInfo.id!=undefined&&
                    this.addUserInfo.id!=null&&
                    this.addUserInfo.id!=''
                ){//修改操作
                    if("******"==this.addUserInfo.password){
                        this.addUserInfo.password = null
                    }else{
                        this.addUserInfo.password = md5(this.addUserInfo.password)
                    }
                    this.addUserInfo.createDate = null
                    this.addUserInfo.updateDate = null
                    updateWxUser(this.addUserInfo).then(res=>{
                        if (res!=undefined&&res.resultCode === ERR_OK) {
                            this.handleClose()
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            });

                            this.topage(this.pageNo);
                        }
                    })
                }else{//新增菜单操作
                    this.addUserInfo.password = md5(this.addUserInfo.password)
                    saveUser(this.addUserInfo).then(res=>{
                        if (res!=undefined&&res.resultCode === ERR_OK) {
                            this.handleClose()
                            this.$message({
                                type: 'success',
                                message: '新增成功!'
                            });
                            this.topage(1);
                        }
                    })
                }

            },

        },
        computed: {

        },
        components: {}
    }
</script>

<style scoped>
    .ju-left{
        text-align: right;
        margin-bottom: 20px;
    }
    .sp_add_left{
        width: 45%;
        margin-right: 5%;
    }
    .sp_add_right{
        width: 45%;
    }
</style>
